import { useQuery } from '@apollo/client';
import { graphql, useStaticQuery } from 'gatsby';
import { or } from 'ramda';
import React, { FC } from 'react';

import { keysToCamel } from '@utils/butter';
import { doesNotExist } from '@utils/general';

import { IPageProps } from '@folx-types/flow-steps';
import { IAccountInfoQueryData } from '@folx-types/member';

import ACCOUNT_INFO_QUERY from '@graphql/queries/AccountInfo.query.gql';

import AccountNameEdit, { IAccountNameEditPageContent } from './AccountNameEdit.component';

interface IAccountNameEditPageProps extends IPageProps {}

const AccountNameEditPage: FC<IAccountNameEditPageProps> = ({ path }) => {
	const { pageContent } = useStaticQuery(graphql`
		{
			pageContent: butterPage(slug: { eq: "account-name-edit" }) {
				page_header
				page_info
				first_name_label
				last_name_label
				legal_first_name_label
				legal_last_name_label
				name_tooltip_title
				name_tooltip
				legal_name_tooltip_title
				legal_name_tooltip
				same_legal_name_fineprint
				legal_name_label
				legal_name_disclaimer
			}
		}
	`);

	const {
		loading: accountLoading,
		data: accountData,
		error: accountError,
	} = useQuery<IAccountInfoQueryData>(ACCOUNT_INFO_QUERY);

	const member = accountData?.currentMember;

	const refinedContent: IAccountNameEditPageContent = keysToCamel(
		pageContent
	) as IAccountNameEditPageContent;

	return (
		<AccountNameEdit
			pageContent={refinedContent}
			path={path}
			loading={accountLoading}
			member={member}
			noAccountName={or(doesNotExist(member?.legalFirstName), doesNotExist(member?.legalLastName))}
		/>
	);
};

export default AccountNameEditPage;
